import { useEffect, useImperativeHandle, useMemo, useState } from 'react';

import { isEmpty } from 'lib/helpers/utility';

import { generateNarrative } from 'components/practice/charts/ClinicalNote/lib/advancedFormsHelpers';

export const useAdvancedFormSync = ({
  noteType,
  currentForm,
  setCurrentForm,
  setNarrativeUpdated,
  currAdvForm,
  sectionRef,
  setPatientResponseSidebar,
  formDataKey
}) => {
  const [isMounted, setIsMounted] = useState(false);
  const [syncON, setSyncON] = useState(true);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const formData = useMemo(
    () => ({
      [formDataKey]: currentForm,
      ...(noteType && { customNoteType: noteType })
    }),
    [formDataKey, currentForm, noteType]
  );

  const currentFormId = currentForm?.form_id ?? currentForm?.id;

  useImperativeHandle(
    sectionRef,
    () => ({
      formData,
      patientResponse: () =>
        setPatientResponseSidebar((prev) => ({
          ...prev,
          view: 'patient_response',
          formId: currentFormId,
          open: true
        }))
    }),
    [formData, currentFormId]
  );

  useEffect(() => {
    const shouldGenerateNarrativeInitially =
      currentForm?.form_id && !currAdvForm?.form_id && isEmpty(currentForm?.narrative);

    if (shouldGenerateNarrativeInitially) {
      generateNarrative({ currentForm, setCurrentForm, setNarrativeUpdated });
    }
  }, [currentForm?.form_id]);

  return { isMounted, syncON, setSyncON };
};
